import { z } from 'zod';
export const addCalendarSourceRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(100),
    kind: z.enum(['ical', 'treatwell']),
    url: z.string().max(4096).optional(),
})
    .refine((value) => value.kind !== 'ical' || Boolean(value.url), {
    message: 'Enter the calendar subscription link',
    path: ['url'],
});
//# sourceMappingURL=calendar-ical.js.map